module.exports = __webpack_public_path__ + "img/header-weddingRingsCarbon@2x.9e6950b.jpg";